<div class="py-3 px-3">
  <div class="title">
    <i class="fg fg-vuesaxlinearEssetionalwarning-2 title--icon"></i>
    <strong class="font-18">Solicitação em andamento</strong>
    <i class="fg fg-vuesaxlinearEssetionalclose-circle title--close" (click)="close()"></i>
  </div>
  <div class="p-2">
    <p>Novo usuário cadastrado com sucesso! Agora só falta o compliance para liberar o acesso.</p>
    <p>O compliance já está em andamento, aguardar contato da área responsável.</p>
  </div>
</div>
